import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ReactComponent as HomeIcon } from '../../../assets/home-icon.svg';
import '../Navbar.css';

const HomeNav = () => {
    const trips = useSelector((state) => state.allTrips.trips);
    console.log(trips);

    const [tripsArray, setTripsArray] = useState([]);

  useEffect(() => {
    console.log("Trips from Redux:", trips);  // Log trips from Redux
    const tripsArr = Object.values(trips);  // Convert the trips object to an array
    console.log("Converted trips array:", tripsArr);  // Log the trips array

    setTripsArray(tripsArr);  // Set the trips array in state
    }, [trips]);
    

    

    return (
        <nav>
         <h1>Tripmate</h1>
         <div className="all-trips-header">
            <HomeIcon className = "home-icon"/>
            <h2>All Trips</h2>
         </div>   
            <ul className="alltrips-list">
                {tripsArray.length > 0 ? (
                  tripsArray.map((trip) => (
                    <li className="alltrips-list-item"
                     key={trip.TRIP_ID}>
                       <Link to={`/edit-trip/${trip.TRIP_ID}`} className="trip-link">
                       {trip.TRIP_NAME}
                       </Link>
                    </li>
                )) 
            ): (
                    <li>No trips available</li>
                )}
            </ul>
        </nav>
    );
};

export default HomeNav;